import { render } from "./SidebarAdmin.vue?vue&type=template&id=2bc80793"
import script from "./SidebarAdmin.vue?vue&type=script&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&lang=js"

import "./SidebarAdmin.vue?vue&type=style&index=0&id=2bc80793&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__